<template>
  <section>
    <h2 class="h2Title">회원 정보</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              <v-icon>mdi-account</v-icon>
              회원정보
            </v-tab>

            <v-tab href="#tab-2" :disabled="!userId">
              <v-icon>mdi-currency-krw</v-icon>
              알림내역
            </v-tab>
            <v-tab href="#tab-3" :disabled="!userId">
              <v-icon>mdi-receipt</v-icon>
              신청내역
            </v-tab>
            <v-tab-item value="tab-1" key="1">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <sec-user-form :user-id="userId"/>
            </v-tab-item>
            <v-tab-item value="tab-2" key="2">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <sms-history :recipient-id="userId" :present="true"/>

              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <a @click="$router.go(-1)">
                    <v-btn class="vBtn" color="#fafafa">
                      <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                      회원 목록
                    </v-btn>
                  </a>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item value="tab-3" key="3">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <component :is="orderComponentType" :user-id="userId" @callback-type="changeOrderComponent"/>

              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <a @click="$router.go(-1)">
                    <v-btn class="vBtn" color="#fafafa">
                      <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                      회원 목록
                    </v-btn>
                  </a>
                </div>
              </div>
            </v-tab-item>

          </v-tabs>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import SecUserForm from "@/views/user/tabs/SecUserForm";
import SmsHistory from "@/views/sms/SmsHistory";
import OrderComponent from "@/views/present/tabs/Order"
import OrderFormComponent from "@/views/present/tabs/OrderForm"

// import _ from 'lodash';

export default {
  name: "UserForm",
  components: {
    SecUserForm,
    SmsHistory,
    OrderComponent,
    OrderFormComponent
  },
  props: {
    userId: String
    // item: Object
  },
  watch: {
  },
  data: () => (
      {
        orderComponentType: "OrderComponent"
      }),
  computed: {

  },
  methods: {
    changeOrderComponent(param) {
      if(param.type === 'form') {
        this.orderComponentType = 'OrderFormComponent'
      } else
        this.orderComponentType = 'OrderComponent'
    }
  },
  created() {



  }
}
</script>

